// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/hydrant-map-item-icon-schema',
  type: 'object',
  required: [],
  properties: {
    iconType: {
      type: 'string',
      nullable: true,
    },
    iconColor: {
      type: 'string',
      nullable: true,
    },
  },
} as IJSONSchema;

export default schema;
